import posthog from "posthog-js";

// get posthog key from meta
const metaKey = document.querySelector("meta[name='posthog_key']") as HTMLMetaElement | null;
const metaHost = document.querySelector("meta[name='posthog_host']") as HTMLMetaElement | null;
const key = metaKey?.content;
const host = metaHost?.content;

if (key) {
  posthog.init(key, {
    api_host: host || "https://eu.i.posthog.com",
    ui_host: "https://eu.posthog.com",
    person_profiles: "identified_only",
    cookieless_mode: "always",
    defaults: "2025-05-24",
    // Enable debug mode in development
    loaded: (posthog) => {
      if (process.env.NODE_ENV === "development") posthog.debug();
    },
  });
}

const toolbarJSON = new URLSearchParams(window.location.hash.substring(1)).get("__posthog");
if (toolbarJSON) {
  posthog.loadToolbar(JSON.parse(toolbarJSON));
}

export { posthog };
